import styled, { css } from 'styled-components'
import placeholder from '../../assets/tr-placeholder.jpg'
import { colors } from '../../styles'

interface ITrPlaceholder {
  src: string
  size?: number
  bordered?: boolean
}

export const TrPlaceholder = styled.img.attrs({
  src: placeholder,
})<ITrPlaceholder>`
  ${({ size }) =>
    size &&
    css`
      max-width: ${size};
      max-height: ${size};
    `}
  ${({ bordered }) =>
    bordered &&
    css`
      border: 1px solid ${colors.grey10};
    `}
` as React.ComponentType<any>
